/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './procedure-implant.reducer';

export const ProcedureImplantDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const procedureImplantEntity = useAppSelector(state => state.procedureImplant.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="procedureImplantDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.procedureImplant.detail.title">ProcedureImplant</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.procedureImplant.id">Id</Translate>
            </span>
          </dt>
          <dd>{procedureImplantEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.procedureImplant.active">Active</Translate>
            </span>
          </dt>
          <dd>{procedureImplantEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.procedureImplant.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{procedureImplantEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.procedureImplant.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{procedureImplantEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.procedureImplant.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{procedureImplantEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.procedureImplant.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{procedureImplantEntity.timestampentry}</dd>
          <dt>
            <span id="quantity">
              <Translate contentKey="tinyMedicRestApp.procedureImplant.quantity">Quantity</Translate>
            </span>
          </dt>
          <dd>{procedureImplantEntity.quantity}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.procedureImplant.implant">Implant</Translate>
          </dt>
          <dd>{procedureImplantEntity.implant ? procedureImplantEntity.implant.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.procedureImplant.procedure">Procedure</Translate>
          </dt>
          <dd>{procedureImplantEntity.procedure ? procedureImplantEntity.procedure.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/procedure-implant" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/procedure-implant/${procedureImplantEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ProcedureImplantDetail;
